// Generated by apps/server/scripts/ice-gen.ts (seed 7). Do not edit by hand —
// rerun `pnpm --filter @xox/server gen:ice --seed 7 --write`.
import type { Level } from './types'

export const GENERATED_LEVELS: readonly Level[] = [
  {
    id: 't1-03',
    name: 'Frozen Lake 3',
    par: 5,
    tier: 1,
    rows: [
      '##########',
      '##...#...#',
      '#.#.#....#',
      '#........#',
      '#.....D..#',
      '#..#..#..#',
      '##......##',
      '#.#.S.#o.#',
      '#.......##',
      '##########',
    ],
  },
  {
    id: 't1-04',
    name: 'Frozen Lake 4',
    par: 5,
    tier: 1,
    rows: [
      '##########',
      '#...#.#.D#',
      '#....#...#',
      '#.##....##',
      '#......#.#',
      '##.#....o#',
      '#.......##',
      '##..S.#.o#',
      '#........#',
      '##########',
    ],
  },
  {
    id: 't1-05',
    name: 'Frozen Lake 5',
    par: 5,
    tier: 1,
    rows: [
      '##########',
      '##...#...#',
      '##......##',
      '#.#.oS..##',
      '#o..#..#.#',
      '##...o...#',
      '#..#....##',
      '#......D.#',
      '#.....#..#',
      '##########',
    ],
  },
  {
    id: 't1-06',
    name: 'Frozen Lake 6',
    par: 6,
    tier: 1,
    rows: [
      '##########',
      '#.....#.##',
      '#........#',
      '#..#....##',
      '##....#..#',
      '#...S...##',
      '##.....o.#',
      '#...##..o#',
      '#.#..D..##',
      '##########',
    ],
  },
  {
    id: 't1-07',
    name: 'Frozen Lake 7',
    par: 6,
    tier: 1,
    rows: [
      '##########',
      '#.#o.....#',
      '#........#',
      '#...#....#',
      '##.......#',
      '#....#...#',
      '#.....S.o#',
      '#.....o.D#',
      '#.#......#',
      '##########',
    ],
  },
  {
    id: 't1-08',
    name: 'Frozen Lake 8',
    par: 7,
    tier: 1,
    rows: [
      '##########',
      '#..#.....#',
      '#........#',
      '#......###',
      '#.......##',
      '#.#.....o#',
      '#So......#',
      '#...o...D#',
      '#.#.#....#',
      '##########',
    ],
  },
  {
    id: 't1-09',
    name: 'Frozen Lake 9',
    par: 7,
    tier: 1,
    rows: [
      '##########',
      '#.o.D..#.#',
      '#.#.#....#',
      '#..o...#.#',
      '#........#',
      '#.#...#..#',
      '#o##....##',
      '#..#.....#',
      '#.....#S.#',
      '##########',
    ],
  },
  {
    id: 't1-10',
    name: 'Frozen Lake 10',
    par: 7,
    tier: 1,
    rows: [
      '##########',
      '#........#',
      '#o#.#S#.o#',
      '#.#......#',
      '#......#.#',
      '#......#.#',
      '#oD..#...#',
      '##.......#',
      '#...#....#',
      '##########',
    ],
  },
  {
    id: 't1-11',
    name: 'Frozen Lake 11',
    par: 8,
    tier: 1,
    rows: [
      '##########',
      '#o..#....#',
      '#........#',
      '#..#.#...#',
      '##..o....#',
      '#...o....#',
      '#....#...#',
      '#.#.S.#.D#',
      '#....o...#',
      '##########',
    ],
  },
  {
    id: 't1-12',
    name: 'Frozen Lake 12',
    par: 8,
    tier: 1,
    rows: [
      '##########',
      '#..D.o...#',
      '#.o......#',
      '#........#',
      '##.o...o.#',
      '#......#.#',
      '#..#.....#',
      '#.#......#',
      '#..S..#..#',
      '##########',
    ],
  },
  {
    id: 't2-01',
    name: 'Wind Tunnels 1',
    par: 9,
    tier: 2,
    intro: 'Arrows shove you in a new direction mid-slide.',
    rows: [
      '##########',
      '#.....#..#',
      '#.o.^....#',
      '#o#...o..#',
      '#.o.....D#',
      '#..#.....#',
      '##...>..##',
      '#....#...#',
      '#.....S..#',
      '##########',
    ],
  },
  {
    id: 't2-02',
    name: 'Wind Tunnels 2',
    par: 8,
    tier: 2,
    rows: [
      '##########',
      '#...#..vo#',
      '#..#.....#',
      '#....oS#.#',
      '#.......##',
      '#...#...D#',
      '#o.......#',
      '#........#',
      '#...##o..#',
      '##########',
    ],
  },
  {
    id: 't2-03',
    name: 'Wind Tunnels 3',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '#.#.....o#',
      '#.#....S.#',
      '#........#',
      '#.....#..#',
      '##..<D...#',
      '##o......#',
      '#....oo..#',
      '#....#...#',
      '##########',
    ],
  },
  {
    id: 't2-04',
    name: 'Wind Tunnels 4',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '#..#.....#',
      '#.......##',
      '#.....D..#',
      '#o......^#',
      '#.#.....o#',
      '#....o...#',
      '#...S.<.##',
      '#.#..o...#',
      '##########',
    ],
  },
  {
    id: 't2-05',
    name: 'Wind Tunnels 5',
    par: 6,
    tier: 2,
    rows: [
      '##########',
      '#D.o...v.#',
      '#..#.....#',
      '#......#.#',
      '##.##..#.#',
      '#..#....S#',
      '#........#',
      '#..##....#',
      '#..#...o.#',
      '##########',
    ],
  },
  {
    id: 't2-06',
    name: 'Wind Tunnels 6',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '###.<....#',
      '#....#oo.#',
      '#..#...v.#',
      '#.S.#.<..#',
      '#..#...#o#',
      '##..##..##',
      '#...#....#',
      '#.#oD..>.#',
      '##########',
    ],
  },
  {
    id: 't2-07',
    name: 'Wind Tunnels 7',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '#Dv^o.####',
      '#.....#<.#',
      '###.<....#',
      '#...#....#',
      '#..#.#...#',
      '##.o...#.#',
      '#o..#..S.#',
      '#..o...#.#',
      '##########',
    ],
  },
  {
    id: 't2-08',
    name: 'Wind Tunnels 8',
    par: 7,
    tier: 2,
    rows: [
      '##########',
      '#.###....#',
      '#.#....###',
      '#v.#.....#',
      '##.D.....#',
      '#.#^....o#',
      '#........#',
      '#o#.....o#',
      '#.....#S.#',
      '##########',
    ],
  },
  {
    id: 't2-09',
    name: 'Wind Tunnels 9',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '#......#o#',
      '#.#....S.#',
      '##...##..#',
      '#..#..Do.#',
      '#.#.....>#',
      '##..o.o#.#',
      '#....>#..#',
      '#.v......#',
      '##########',
    ],
  },
  {
    id: 't2-10',
    name: 'Wind Tunnels 10',
    par: 8,
    tier: 2,
    rows: [
      '##########',
      '#.......>#',
      '#........#',
      '##.#.....#',
      '#..#...o##',
      '#....o..##',
      '#S##.D.#o#',
      '#...#.#.v#',
      '#..#.....#',
      '##########',
    ],
  },
  {
    id: 't2-11',
    name: 'Wind Tunnels 11',
    par: 8,
    tier: 2,
    rows: [
      '##########',
      '##...#.o##',
      '##o....#.#',
      '#.S..o#..#',
      '#........#',
      '#..#.....#',
      '##.D...<>#',
      '#......#.#',
      '#...^....#',
      '##########',
    ],
  },
  {
    id: 't2-12',
    name: 'Wind Tunnels 12',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '###.^.#..#',
      '#...#....#',
      '##.....#.#',
      '#..##....#',
      '#......D##',
      '#.o.^..oo#',
      '#.S...#.o#',
      '#.^......#',
      '##########',
    ],
  },
  {
    id: 't2-13',
    name: 'Wind Tunnels 13',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '#...#...##',
      '#.>Do<.#o#',
      '#...^....#',
      '#<.##....#',
      '#..o#S..##',
      '#.#....#.#',
      '#.......##',
      '#..#....o#',
      '##########',
    ],
  },
  {
    id: 't2-14',
    name: 'Wind Tunnels 14',
    par: 9,
    tier: 2,
    rows: [
      '##########',
      '##o.v#...#',
      '#.#v.o...#',
      '#D...o#..#',
      '##...#..##',
      '#.....S.##',
      '#v..#....#',
      '##...o#..#',
      '#....#^..#',
      '##########',
    ],
  },
  {
    id: 't3-01',
    name: 'Flicker Field 1',
    par: 6,
    tier: 3,
    intro: 'Flickering rocks are solid on even moves and vanish on odd ones. Count your moves.',
    rows: [
      '##########',
      '#..D..^..#',
      '#...#....#',
      '##.......#',
      '#=......##',
      '#........#',
      '#..o.#..##',
      '#..S.....#',
      '#........#',
      '##########',
    ],
  },
  {
    id: 't3-02',
    name: 'Flicker Field 2',
    par: 6,
    tier: 3,
    rows: [
      '##########',
      '#.......##',
      '#....#..##',
      '##=#...=.#',
      '#..##....#',
      '#...o..D.#',
      '#........#',
      '#.#..S...#',
      '##...^...#',
      '##########',
    ],
  },
  {
    id: 't3-03',
    name: 'Flicker Field 3',
    par: 7,
    tier: 3,
    rows: [
      '##########',
      '##...#...#',
      '#...#D...#',
      '#...#..<o#',
      '#........#',
      '#S#......#',
      '##.=....##',
      '#..#...#.#',
      '#........#',
      '##########',
    ],
  },
  {
    id: 't3-04',
    name: 'Flicker Field 4',
    par: 7,
    tier: 3,
    rows: [
      '##########',
      '#.=......#',
      '#..#...D##',
      '#..S.....#',
      '#.o...#..#',
      '#..#.....#',
      '##.......#',
      '#>.=....##',
      '#..#...###',
      '##########',
    ],
  },
  {
    id: 't3-05',
    name: 'Flicker Field 5',
    par: 7,
    tier: 3,
    rows: [
      '##########',
      '#...^.=..#',
      '#<..S....#',
      '#...#.#.o#',
      '#.#......#',
      '####=....#',
      '#......#.#',
      '#..#.....#',
      '#o....D.##',
      '##########',
    ],
  },
  {
    id: 't3-06',
    name: 'Flicker Field 6',
    par: 8,
    tier: 3,
    rows: [
      '##########',
      '###..o=<S#',
      '#.D...#..#',
      '#........#',
      '#....o.=.#',
      '###.##...#',
      '#........#',
      '#.....#.##',
      '#..#..#..#',
      '##########',
    ],
  },
  {
    id: 't3-07',
    name: 'Flicker Field 7',
    par: 8,
    tier: 3,
    rows: [
      '##########',
      '#S.......#',
      '#..o.....#',
      '#..#=#...#',
      '##o.....>#',
      '#........#',
      '#....D...#',
      '##...#=.>#',
      '#........#',
      '##########',
    ],
  },
  {
    id: 't3-08',
    name: 'Flicker Field 8',
    par: 8,
    tier: 3,
    rows: [
      '##########',
      '##.......#',
      '#.S=####.#',
      '#..#..ooo#',
      '#..D....##',
      '#...=....#',
      '#..#.#...#',
      '#v.......#',
      '#..^.....#',
      '##########',
    ],
  },
  {
    id: 't3-09',
    name: 'Flicker Field 9',
    par: 8,
    tier: 3,
    rows: [
      '##########',
      '#..#.....#',
      '#....>..##',
      '#.##.o...#',
      '#.#...<..#',
      '#.......##',
      '##D.oS...#',
      '##.=#...=#',
      '#.##.#.=o#',
      '##########',
    ],
  },
  {
    id: 't3-10',
    name: 'Flicker Field 10',
    par: 9,
    tier: 3,
    rows: [
      '##########',
      '#o=..#.#.#',
      '##......##',
      '#S...o..##',
      '#.#..#o#.#',
      '#.#.....##',
      '#......=.#',
      '#......#.#',
      '#..v.^.D.#',
      '##########',
    ],
  },
  {
    id: 't3-11',
    name: 'Flicker Field 11',
    par: 9,
    tier: 3,
    rows: [
      '##########',
      '#..o=o...#',
      '##.....#.#',
      '#...=o^..#',
      '#.#.^...##',
      '#..#.#...#',
      '#..#S....#',
      '#.D..o^=.#',
      '#..#.....#',
      '##########',
    ],
  },
  {
    id: 't3-12',
    name: 'Flicker Field 12',
    par: 9,
    tier: 3,
    rows: [
      '##########',
      '#=...#.o.#',
      '#...#>..##',
      '#..#.#...#',
      '#.=....#.#',
      '##D#.=S#.#',
      '##....^..#',
      '#.o......#',
      '###.....o#',
      '##########',
    ],
  },
  {
    id: 't3-13',
    name: 'Flicker Field 13',
    par: 10,
    tier: 3,
    rows: [
      '##########',
      '#..=o#..o#',
      '#.D...#..#',
      '#....o<..#',
      '#.>...#..#',
      '#.o......#',
      '#.#....###',
      '#.####=.>#',
      '#...#.S..#',
      '##########',
    ],
  },
  {
    id: 't3-14',
    name: 'Flicker Field 14',
    par: 10,
    tier: 3,
    rows: [
      '##########',
      '#..^.....#',
      '#...D.o..#',
      '##.......#',
      '#=......##',
      '#........#',
      '#o##o<S..#',
      '#..=....^#',
      '#=o#..#..#',
      '##########',
    ],
  },
  {
    id: 't4-01',
    name: 'Cracking Ice 1',
    par: 7,
    tier: 4,
    intro: 'Cracked ice breaks after you cross it — and never stop on it.',
    rows: [
      '##########',
      '#......#.#',
      '##.~o..#.#',
      '#........#',
      '#......D.#',
      '#v..#....#',
      '#.#......#',
      '#S.......#',
      '#...#...##',
      '##########',
    ],
  },
  {
    id: 't4-02',
    name: 'Cracking Ice 2',
    par: 7,
    tier: 4,
    rows: [
      '##########',
      '#.#...##~#',
      '#...~..#.#',
      '##...D..o#',
      '#....##o.#',
      '#...#...##',
      '#.....#..#',
      '#..#^.S..#',
      '#...#....#',
      '##########',
    ],
  },
  {
    id: 't4-03',
    name: 'Cracking Ice 3',
    par: 8,
    tier: 4,
    rows: [
      '##########',
      '#..#^~...#',
      '#D~....#.#',
      '#.#......#',
      '#...#....#',
      '#..#...#.#',
      '#..#.#.<##',
      '#.o.S....#',
      '#...o....#',
      '##########',
    ],
  },
  {
    id: 't4-04',
    name: 'Cracking Ice 4',
    par: 8,
    tier: 4,
    rows: [
      '##########',
      '#...S#...#',
      '#...o....#',
      '#...#....#',
      '#<....#..#',
      '#.#...D..#',
      '#..#.v...#',
      '#.#......#',
      '#..#.#.~.#',
      '##########',
    ],
  },
  {
    id: 't4-05',
    name: 'Cracking Ice 5',
    par: 8,
    tier: 4,
    rows: [
      '##########',
      '#..#.....#',
      '#~S~..#..#',
      '#........#',
      '#....o...#',
      '#.#......#',
      '#......###',
      '#oD.....##',
      '#....v..##',
      '##########',
    ],
  },
  {
    id: 't4-06',
    name: 'Cracking Ice 6',
    par: 8,
    tier: 4,
    rows: [
      '##########',
      '#.S......#',
      '#o...#...#',
      '#D~<#....#',
      '#.#.....##',
      '#....v...#',
      '#..o.....#',
      '#..#~....#',
      '#..#.....#',
      '##########',
    ],
  },
  {
    id: 't4-07',
    name: 'Cracking Ice 7',
    par: 9,
    tier: 4,
    rows: [
      '##########',
      '#.#.....##',
      '#.....#..#',
      '#.~..#o.##',
      '#.....S~.#',
      '#<.......#',
      '#....D.#.#',
      '#>.#...o.#',
      '#.o......#',
      '##########',
    ],
  },
  {
    id: 't4-08',
    name: 'Cracking Ice 8',
    par: 9,
    tier: 4,
    rows: [
      '##########',
      '#......S##',
      '#....o.#.#',
      '#<.....#.#',
      '#.~......#',
      '#....~v..#',
      '##..D....#',
      '#..o....##',
      '#.......##',
      '##########',
    ],
  },
  {
    id: 't4-09',
    name: 'Cracking Ice 9',
    par: 9,
    tier: 4,
    rows: [
      '##########',
      '#...#..o.#',
      '#.D#...~.#',
      '##...<..##',
      '#..#>#...#',
      '#..o.#...#',
      '#o#......#',
      '#S~...#..#',
      '#.....####',
      '##########',
    ],
  },
  {
    id: 't4-10',
    name: 'Cracking Ice 10',
    par: 10,
    tier: 4,
    rows: [
      '##########',
      '#..#.....#',
      '##.S.o##.#',
      '##.......#',
      '#..o.~.D##',
      '#...##<#.#',
      '#......~v#',
      '#......#.#',
      '#.#..>.o##',
      '##########',
    ],
  },
  {
    id: 't4-11',
    name: 'Cracking Ice 11',
    par: 10,
    tier: 4,
    rows: [
      '##########',
      '##.#.~.o.#',
      '#......#>#',
      '#.#..#...#',
      '#.#.#....#',
      '#......<S#',
      '##..oo#.##',
      '#...D...<#',
      '##...#..~#',
      '##########',
    ],
  },
  {
    id: 't4-12',
    name: 'Cracking Ice 12',
    par: 10,
    tier: 4,
    rows: [
      '##########',
      '#....^...#',
      '#...#..#.#',
      '#....~.#.#',
      '#.o.D....#',
      '##..o..~.#',
      '#...#.#..#',
      '#.o#.....#',
      '#.S<~.#.>#',
      '##########',
    ],
  },
  {
    id: 't4-13',
    name: 'Cracking Ice 13',
    par: 10,
    tier: 4,
    rows: [
      '##########',
      '#.S.>.~.##',
      '#o...~..##',
      '#..<....##',
      '#...o<##D#',
      '#~..o....#',
      '#.#.#...##',
      '#..#....##',
      '#....#...#',
      '##########',
    ],
  },
  {
    id: 't4-14',
    name: 'Cracking Ice 14',
    par: 11,
    tier: 4,
    rows: [
      '##########',
      '#.S....~##',
      '#..o.D...#',
      '#.v....o.#',
      '#o.<#~#..#',
      '#......o##',
      '#.#.#....#',
      '#..#...~.#',
      '##..v..#.#',
      '##########',
    ],
  },
  {
    id: 't4-15',
    name: 'Cracking Ice 15',
    par: 11,
    tier: 4,
    rows: [
      '##########',
      '#~.###...#',
      '##.......#',
      '#..<#.#.S#',
      '#o.#o.o..#',
      '##..#...~#',
      '#^..#D...#',
      '#....~.<o#',
      '#.#...#..#',
      '##########',
    ],
  },
  {
    id: 't5-01',
    name: 'Yeti Country 1',
    par: 7,
    tier: 5,
    intro: 'Yetis patrol the ice and take one step after each of your moves. Do not touch them.',
    rows: [
      '##########',
      '#........#',
      '##<.D##..#',
      '#........#',
      '#......o.#',
      '#..S.....#',
      '#.......##',
      '##.......#',
      '#...##.#.#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 3 },
          { r: 3, c: 4 },
          { r: 3, c: 5 },
          { r: 3, c: 6 },
        ],
      },
    ],
  },
  {
    id: 't5-02',
    name: 'Yeti Country 2',
    par: 7,
    tier: 5,
    rows: [
      '##########',
      '#....#...#',
      '#<.......#',
      '#........#',
      '#........#',
      '#.#..#..##',
      '#..D#..#.#',
      '#.o.#..###',
      '#.S...#..#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 1, c: 2 },
          { r: 2, c: 2 },
          { r: 3, c: 2 },
          { r: 4, c: 2 },
        ],
      },
    ],
  },
  {
    id: 't5-03',
    name: 'Yeti Country 3',
    par: 8,
    tier: 5,
    rows: [
      '##########',
      '#....#...#',
      '#So......#',
      '##.......#',
      '#...#...##',
      '#...o..#.#',
      '#..D.....#',
      '#...#....#',
      '#.<......#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 8, c: 4 },
          { r: 8, c: 5 },
          { r: 8, c: 6 },
          { r: 8, c: 7 },
        ],
      },
    ],
  },
  {
    id: 't5-04',
    name: 'Yeti Country 4',
    par: 8,
    tier: 5,
    rows: [
      '##########',
      '#......#.#',
      '##.##...##',
      '#.S......#',
      '#.#......#',
      '#....#..##',
      '#.......^#',
      '#.....oD.#',
      '#.....#..#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 4, c: 4 },
          { r: 5, c: 4 },
          { r: 6, c: 4 },
          { r: 7, c: 4 },
        ],
      },
    ],
  },
  {
    id: 't5-05',
    name: 'Yeti Country 5',
    par: 8,
    tier: 5,
    rows: [
      '##########',
      '#..##....#',
      '#..#....S#',
      '#o##...o.#',
      '#........#',
      '##.......#',
      '#D...#...#',
      '#.....##^#',
      '#.#......#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 4, c: 4 },
          { r: 5, c: 4 },
          { r: 6, c: 4 },
        ],
      },
    ],
  },
  {
    id: 't5-06',
    name: 'Yeti Country 6',
    par: 9,
    tier: 5,
    rows: [
      '##########',
      '#.#..#...#',
      '#.....#..#',
      '#...v....#',
      '#..o.....#',
      '#S.###...#',
      '####....>#',
      '##.o....##',
      '#D.....#.#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 5 },
          { r: 3, c: 6 },
          { r: 3, c: 7 },
          { r: 3, c: 8 },
        ],
      },
    ],
  },
  {
    id: 't5-07',
    name: 'Yeti Country 7',
    par: 9,
    tier: 5,
    rows: [
      '##########',
      '#....#...#',
      '#...#v..o#',
      '#.....D..#',
      '#..#...#.#',
      '##....#S.#',
      '#.#......#',
      '#..#..o.##',
      '#.#..#...#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 2, c: 1 },
          { r: 2, c: 2 },
        ],
      },
    ],
  },
  {
    id: 't5-08',
    name: 'Yeti Country 8',
    par: 10,
    tier: 5,
    rows: [
      '##########',
      '##......S#',
      '#.>#o##..#',
      '#.....##<#',
      '#...#....#',
      '#......#.#',
      '#.o.#.#..#',
      '#.....D..#',
      '#...#..#.#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 7, c: 1 },
          { r: 7, c: 2 },
          { r: 7, c: 3 },
          { r: 7, c: 4 },
        ],
      },
    ],
  },
  {
    id: 't5-09',
    name: 'Yeti Country 9',
    par: 10,
    tier: 5,
    rows: [
      '##########',
      '#.<#.....#',
      '##D....#.#',
      '#.###^...#',
      '#.......o#',
      '#.......##',
      '##...<o.##',
      '##.#.S...#',
      '#.....#..#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 1, c: 8 },
          { r: 2, c: 8 },
        ],
      },
      {
        path: [
          { r: 5, c: 7 },
          { r: 6, c: 7 },
          { r: 7, c: 7 },
          { r: 8, c: 7 },
        ],
      },
    ],
  },
  {
    id: 't5-10',
    name: 'Yeti Country 10',
    par: 10,
    tier: 5,
    rows: [
      '##########',
      '#.D.....##',
      '#...o..#.#',
      '#..##...##',
      '#.o#..#..#',
      '##..#.^..#',
      '##...#o..#',
      '#.#....>.#',
      '#....S...#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 8, c: 2 },
          { r: 8, c: 3 },
          { r: 8, c: 4 },
        ],
      },
      {
        path: [
          { r: 1, c: 4 },
          { r: 1, c: 5 },
          { r: 1, c: 6 },
          { r: 1, c: 7 },
        ],
      },
    ],
  },
  {
    id: 't5-11',
    name: 'Yeti Country 11',
    par: 11,
    tier: 5,
    rows: [
      '##########',
      '#....#...#',
      '#o.....#.#',
      '#D..#....#',
      '#..>....##',
      '#....#..##',
      '#........#',
      '#..o.>...#',
      '#.o.S#...#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 4, c: 7 },
          { r: 5, c: 7 },
          { r: 6, c: 7 },
          { r: 7, c: 7 },
        ],
      },
      {
        path: [
          { r: 2, c: 5 },
          { r: 2, c: 6 },
        ],
      },
    ],
  },
  {
    id: 't5-12',
    name: 'Yeti Country 12',
    par: 11,
    tier: 5,
    rows: [
      '##########',
      '#...o.D###',
      '#....#..^#',
      '#.S..o#..#',
      '#..#.#.#.#',
      '#....^#..#',
      '#.o.#....#',
      '#........#',
      '#...#....#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 7, c: 2 },
          { r: 7, c: 3 },
        ],
      },
    ],
  },
  {
    id: 't5-13',
    name: 'Yeti Country 13',
    par: 11,
    tier: 5,
    rows: [
      '##########',
      '##......##',
      '##.......#',
      '#...#..D.#',
      '#.v......#',
      '#.......S#',
      '#.#..#o.o#',
      '#^.#.o...#',
      '##......##',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 1, c: 3 },
          { r: 1, c: 4 },
          { r: 1, c: 5 },
        ],
      },
      {
        path: [
          { r: 5, c: 2 },
          { r: 5, c: 3 },
          { r: 5, c: 4 },
        ],
      },
    ],
  },
  {
    id: 't5-14',
    name: 'Yeti Country 14',
    par: 12,
    tier: 5,
    rows: [
      '##########',
      '#..#..o#.#',
      '#....#.^S#',
      '#...#....#',
      '#.D..o.#.#',
      '##..#...<#',
      '#oo.....##',
      '##.....v##',
      '###......#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 7, c: 5 },
          { r: 7, c: 6 },
        ],
      },
      {
        path: [
          { r: 1, c: 1 },
          { r: 2, c: 1 },
          { r: 3, c: 1 },
          { r: 4, c: 1 },
        ],
      },
    ],
  },
  {
    id: 't5-15',
    name: 'Yeti Country 15',
    par: 12,
    tier: 5,
    rows: [
      '##########',
      '####.....#',
      '#..D...#.#',
      '#........#',
      '#.#^#.o..#',
      '##.#.o##>#',
      '#..S..<..#',
      '#...o....#',
      '##o......#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 5, c: 2 },
          { r: 6, c: 2 },
          { r: 7, c: 2 },
        ],
      },
      {
        path: [
          { r: 1, c: 5 },
          { r: 2, c: 5 },
        ],
      },
    ],
  },
  {
    id: 't6-01',
    name: 'Locked Doors 1',
    par: 8,
    tier: 6,
    intro: 'The door stays shut until you have crossed the key.',
    rows: [
      '##########',
      '#...#K.###',
      '#...D=<..#',
      '#........#',
      '#....#...#',
      '#........#',
      '#..S.....#',
      '#.o......#',
      '#.....#..#',
      '##########',
    ],
  },
  {
    id: 't6-02',
    name: 'Locked Doors 2',
    par: 8,
    tier: 6,
    rows: [
      '##########',
      '#...#.#..#',
      '#........#',
      '##S...D..#',
      '#...#....#',
      '#o.....#.#',
      '#.#......#',
      '#>.=K....#',
      '#........#',
      '##########',
    ],
  },
  {
    id: 't6-03',
    name: 'Locked Doors 3',
    par: 9,
    tier: 6,
    rows: [
      '##########',
      '##D.vK.#.#',
      '#o.......#',
      '###.....##',
      '##.##<.=.#',
      '#S.......#',
      '#........#',
      '##.......#',
      '#...#...##',
      '##########',
    ],
  },
  {
    id: 't6-04',
    name: 'Locked Doors 4',
    par: 9,
    tier: 6,
    rows: [
      '##########',
      '##o##....#',
      '#D<.....=#',
      '##.......#',
      '#.#.....##',
      '#o.=.....#',
      '##S..#...#',
      '#.#.....##',
      '#K....#.##',
      '##########',
    ],
  },
  {
    id: 't6-05',
    name: 'Locked Doors 5',
    par: 9,
    tier: 6,
    rows: [
      '##########',
      '#.#.##...#',
      '#..o..#..#',
      '#.......##',
      '#....#...#',
      '#=^K...#.#',
      '#.....#..#',
      '#..#.=S..#',
      '#..D.....#',
      '##########',
    ],
  },
  {
    id: 't6-06',
    name: 'Locked Doors 6',
    par: 10,
    tier: 6,
    rows: [
      '##########',
      '#.o..<o#.#',
      '##...S...#',
      '##....v#.#',
      '#...=#D#.#',
      '#.....K..#',
      '#..#.#..=#',
      '#....#.#.#',
      '#........#',
      '##########',
    ],
  },
  {
    id: 't6-07',
    name: 'Locked Doors 7',
    par: 10,
    tier: 6,
    rows: [
      '##########',
      '##.=o#...#',
      '#.>..K...#',
      '#..D.#...#',
      '#...=<.S.#',
      '#........#',
      '#..##....#',
      '#.o....###',
      '#....#.#.#',
      '##########',
    ],
  },
  {
    id: 't6-08',
    name: 'Locked Doors 8',
    par: 11,
    tier: 6,
    rows: [
      '##########',
      '#.....#..#',
      '#..#.....#',
      '#o.#.=.=D#',
      '#........#',
      '#....K...#',
      '#.<..>...#',
      '#..o.S...#',
      '##....#..#',
      '##########',
    ],
  },
  {
    id: 't6-09',
    name: 'Locked Doors 9',
    par: 11,
    tier: 6,
    rows: [
      '##########',
      '#.#....o.#',
      '#.....#..#',
      '#o....^#.#',
      '#.....#.K#',
      '#..D=...=#',
      '#...o...>#',
      '#.S.#....#',
      '#.......##',
      '##########',
    ],
  },
  {
    id: 't6-10',
    name: 'Locked Doors 10',
    par: 11,
    tier: 6,
    rows: [
      '##########',
      '#.^<#.o..#',
      '##.#..K.=#',
      '#........#',
      '##....=.S#',
      '#...>#..##',
      '#........#',
      '#........#',
      '#.D...o..#',
      '##########',
    ],
  },
  {
    id: 't6-11',
    name: 'Locked Doors 11',
    par: 12,
    tier: 6,
    rows: [
      '##########',
      '#........#',
      '#.S...D..#',
      '#...o....#',
      '#=#.=v.###',
      '#.o..#..o#',
      '#K......##',
      '#...^..=.#',
      '#.#.....##',
      '##########',
    ],
  },
  {
    id: 't6-12',
    name: 'Locked Doors 12',
    par: 12,
    tier: 6,
    rows: [
      '##########',
      '#..=o..o.#',
      '#.o.D#..##',
      '#.#......#',
      '#......o.#',
      '#.K.<....#',
      '#.S.>..#.#',
      '#......#.#',
      '#.=..#.v.#',
      '##########',
    ],
  },
  {
    id: 't6-13',
    name: 'Locked Doors 13',
    par: 12,
    tier: 6,
    rows: [
      '##########',
      '#.#..=...#',
      '#...K.o..#',
      '#.....=#.#',
      '#....o...#',
      '#D<o..#<.#',
      '#.....v.=#',
      '#..#.#...#',
      '#.S..o...#',
      '##########',
    ],
  },
  {
    id: 't6-14',
    name: 'Locked Doors 14',
    par: 13,
    tier: 6,
    rows: [
      '##########',
      '#...#....#',
      '#..#....>#',
      '#.......v#',
      '#D=......#',
      '#.#....So#',
      '#.#.#.=..#',
      '#.o.K....#',
      '#.o.>#...#',
      '##########',
    ],
  },
  {
    id: 't6-15',
    name: 'Locked Doors 15',
    par: 13,
    tier: 6,
    rows: [
      '##########',
      '#K^......#',
      '#o.##..<.#',
      '#....#...#',
      '#.<.....##',
      '#=.=D...=#',
      '#....#...#',
      '#.o..oo..#',
      '#.#..S...#',
      '##########',
    ],
  },
  {
    id: 't7-01',
    name: 'The Gauntlet 1',
    par: 9,
    tier: 7,
    intro: 'Everything at once. Good luck.',
    rows: [
      '##########',
      '##.......#',
      '#.=..K...#',
      '#...<....#',
      '#....o...#',
      '##..~D...#',
      '#..#.....#',
      '#...#..#.#',
      '#..##..S.#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 5 },
          { r: 3, c: 6 },
          { r: 3, c: 7 },
          { r: 3, c: 8 },
        ],
      },
    ],
  },
  {
    id: 't7-02',
    name: 'The Gauntlet 2',
    par: 9,
    tier: 7,
    rows: [
      '##########',
      '#.#..#.S.#',
      '#.o.#.~.D#',
      '#......v.#',
      '#.....##.#',
      '#..#.=...#',
      '#.....#..#',
      '#.#.#K...#',
      '#.#......#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 1, c: 1 },
          { r: 2, c: 1 },
          { r: 3, c: 1 },
          { r: 4, c: 1 },
        ],
      },
    ],
  },
  {
    id: 't7-03',
    name: 'The Gauntlet 3',
    par: 10,
    tier: 7,
    rows: [
      '##########',
      '#........#',
      '#......>.#',
      '#..>...K.#',
      '#=.......#',
      '#......###',
      '#~..#=..D#',
      '#.S#.o...#',
      '#.......##',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 1, c: 5 },
          { r: 2, c: 5 },
        ],
      },
    ],
  },
  {
    id: 't7-04',
    name: 'The Gauntlet 4',
    par: 10,
    tier: 7,
    rows: [
      '##########',
      '#.K=....##',
      '#=.......#',
      '#..o.....#',
      '#.....o..#',
      '#....v...#',
      '#D###~...#',
      '#.~...#..#',
      '#..#....S#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 1, c: 7 },
          { r: 2, c: 7 },
        ],
      },
    ],
  },
  {
    id: 't7-05',
    name: 'The Gauntlet 5',
    par: 11,
    tier: 7,
    rows: [
      '##########',
      '#.....~.##',
      '#<....S=K#',
      '#....#o#.#',
      '#.....#.o#',
      '#........#',
      '#.#D.#...#',
      '#........#',
      '#..=#....#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 1 },
          { r: 3, c: 2 },
          { r: 3, c: 3 },
          { r: 3, c: 4 },
        ],
      },
    ],
  },
  {
    id: 't7-06',
    name: 'The Gauntlet 6',
    par: 11,
    tier: 7,
    rows: [
      '##########',
      '#..#S~...#',
      '#....#...#',
      '#.D..o.v.#',
      '##..<=..##',
      '#.....=.##',
      '#..#.#...#',
      '##.#.....#',
      '#~..##o.K#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 4, c: 3 },
          { r: 5, c: 3 },
        ],
      },
    ],
  },
  {
    id: 't7-07',
    name: 'The Gauntlet 7',
    par: 12,
    tier: 7,
    rows: [
      '##########',
      '#.#......#',
      '#.~......#',
      '#.D..S>.##',
      '#.#=....##',
      '#....#...#',
      '#...oo#.=#',
      '#..#.....#',
      '#..~..K..#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 5, c: 2 },
          { r: 6, c: 2 },
          { r: 7, c: 2 },
        ],
      },
    ],
  },
  {
    id: 't7-08',
    name: 'The Gauntlet 8',
    par: 12,
    tier: 7,
    rows: [
      '##########',
      '#....=#..#',
      '#.##D^..##',
      '#..#o...##',
      '#.#o.K#~.#',
      '#...#..~.#',
      '#..=..o..#',
      '#..v...S.#',
      '##..##...#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 5 },
          { r: 3, c: 6 },
          { r: 3, c: 7 },
        ],
      },
    ],
  },
  {
    id: 't7-09',
    name: 'The Gauntlet 9',
    par: 12,
    tier: 7,
    rows: [
      '##########',
      '##..D.=..#',
      '#....~...#',
      '#.o...#v.#',
      '#.K......#',
      '#....o#=.#',
      '#..v.#..##',
      '###^.o..S#',
      '#..#..~..#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 1 },
          { r: 4, c: 1 },
          { r: 5, c: 1 },
          { r: 6, c: 1 },
        ],
      },
    ],
  },
  {
    id: 't7-10',
    name: 'The Gauntlet 10',
    par: 13,
    tier: 7,
    rows: [
      '##########',
      '#.#.=.##.#',
      '#...=...o#',
      '#..##....#',
      '#..DS...##',
      '#.#~~oKo.#',
      '#>.....v.#',
      '#..#....<#',
      '#....#...#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 5 },
          { r: 3, c: 6 },
          { r: 3, c: 7 },
          { r: 3, c: 8 },
        ],
      },
    ],
  },
  {
    id: 't7-11',
    name: 'The Gauntlet 11',
    par: 13,
    tier: 7,
    rows: [
      '##########',
      '#.##..#..#',
      '#.#.....~#',
      '#o...v..S#',
      '##~.....v#',
      '#..D.o...#',
      '#...==..##',
      '#..>#..#.#',
      '##o.K.#.##',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 5, c: 1 },
          { r: 5, c: 2 },
        ],
      },
    ],
  },
  {
    id: 't7-12',
    name: 'The Gauntlet 12',
    par: 14,
    tier: 7,
    rows: [
      '##########',
      '#=.#.....#',
      '#...>.=..#',
      '#^...o=K.#',
      '#..#...#~#',
      '#....#..<#',
      '#.#.....o#',
      '#.o#.....#',
      '#.D..S~.~#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 3, c: 2 },
          { r: 4, c: 2 },
        ],
      },
      {
        path: [
          { r: 6, c: 1 },
          { r: 7, c: 1 },
          { r: 8, c: 1 },
        ],
      },
    ],
  },
  {
    id: 't7-13',
    name: 'The Gauntlet 13',
    par: 14,
    tier: 7,
    rows: [
      '##########',
      '#.#....~##',
      '#.#.oDK.o#',
      '##...=...#',
      '#..<..=#.#',
      '#~.###...#',
      '#S=#.....#',
      '#.vo.#o.##',
      '#..^~#...#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 5, c: 7 },
          { r: 6, c: 7 },
          { r: 7, c: 7 },
        ],
      },
    ],
  },
  {
    id: 't7-14',
    name: 'The Gauntlet 14',
    par: 15,
    tier: 7,
    rows: [
      '##########',
      '#.....#..#',
      '#..o..oD.#',
      '#.#....=##',
      '#^.K=..#=#',
      '#o.~.S...#',
      '#...^....#',
      '#......#o#',
      '#..#..<.~#',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 6, c: 1 },
          { r: 6, c: 2 },
          { r: 6, c: 3 },
        ],
      },
    ],
  },
  {
    id: 't7-15',
    name: 'The Gauntlet 15',
    par: 15,
    tier: 7,
    rows: [
      '##########',
      '#..#..#..#',
      '#o.oS...~#',
      '#.#.o.o=.#',
      '#..D.>#..#',
      '#.......>#',
      '#=..~.K..#',
      '#..~.=...#',
      '##..#<..##',
      '##########',
    ],
    monsters: [
      {
        path: [
          { r: 5, c: 7 },
          { r: 6, c: 7 },
          { r: 7, c: 7 },
        ],
      },
      {
        path: [
          { r: 5, c: 3 },
          { r: 5, c: 4 },
          { r: 5, c: 5 },
        ],
      },
    ],
  },
]
